'use client';
import gsap from 'gsap';
import { useEffect } from 'react';
import { useGSAP } from '@gsap/react';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(useGSAP, ScrollTrigger, SplitText);

export const GsapProvider = ({ children }) => {
  useEffect(() => {
    ScrollTrigger.refresh();
  }, []);

  return <>{children}</>;
};
